import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const DarkModeIcon = React.forwardRef<SVGSVGElement, IconProps>(function DarkModeIcon(props, ref) {
    return (
        <IconBase ref={ref} viewBox="0 0 24 24" {...props}>
            <path fill="currentColor" d="M12 3a9 9 0 1 0 9 9q0-.7-.1-1.36a5.4 5.4 0 0 1-4.4 2.26 5.4 5.4 0 0 1-3.14-9.8Q12.69 3 12 3"/>
        </IconBase>
    );
});
